import { render, staticRenderFns } from "./SalesHistoryPanel.vue?vue&type=template&id=c66166a4&scoped=true&"
import script from "./SalesHistoryPanel.vue?vue&type=script&lang=ts&"
export * from "./SalesHistoryPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SalesHistoryPanel.vue?vue&type=style&index=0&id=c66166a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66166a4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn})
